import React from "react";

export default ({ children, config }) => {
  return (
    <div className="btn-group" role="group">
      {children}
    </div>
  );
};
